<template>
  <div
    class="member-collection-benefits"
    data-ui="member-collection-benefits"
  >
    <cdr-img
      class="member-collection-benefits__decorative-image
        member-collection-benefits__decorative-image--top"
      src="/assets/membership/member-collection/ripped-edge-top/live.svg"
      aria-hidden="true"
    />
    <h2
      v-if="heading"
      class="member-collection-benefits__title"
      v-html="heading"
    />
    <ul class="member-collection-benefits__cards">
      <StepCard
        v-for="({ ...rest }, index) in benefitsCards"
        :key="`benefit-card-${index}`"
        :index="index"
        v-bind="rest"
      />
    </ul>
    <div
      class="member-collection-benefits__ctas"
      data-analytics-config="exclude-all"
    >
      <!-- /* c8 ignore start */ -->
      <add-membership-to-cart
        v-if="!userInformation.user.isMember"
        :cta-text="homePageInjectables.addMembershipToCart"
        :is-added-to-cart="membershipInCart"
        class="member-collection-benefits__membership-btn"
        data-ui="member-collection-benefits-btn"
        @click="handleMembershipClick"
        @error="(message) => $emit('error', message)"
        @warn="(message) => $emit('warn', message)"
        @success="$emit('success')"
      />
      <!-- /* c8 ignore end */ -->

      <cdr-button
        :href="benefitsCtaHref"
        class="member-collection-benefits__benefits-btn"
        modifier="secondary"
        tag="a"
        @click="handleClick"
      >
        {{ benefitsCtaText }}
      </cdr-button>
    </div>
    <cdr-img
      class="member-collection-benefits__decorative-image
        member-collection-benefits__decorative-image--bottom"
      src="/assets/membership/member-collection/ripped-edge-bottom/live.svg"
      aria-hidden="true"
    />
  </div>
</template>

<script>
import { CdrButton, CdrImg } from '@rei/cedar';
import AddMembershipToCart from '@rei/add-membership-to-cart';
import StepCard from '../../../common/components/step-cards/StepCard.vue';
import { metricsLink, metricsLinkAddToCart } from '../../../utils/analytics';

export default {
  name: 'MemberCollectionBenefits',
  components: {
    CdrImg,
    CdrButton,
    StepCard,
    AddMembershipToCart,
  },
  inject: ['userInformation', 'homePageInjectables'],
  props: {
    appProps: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    benefitsCtaText: {
      type: String,
      required: true,
    },
    benefitsCtaHref: {
      type: String,
      required: true,
    },
    benefitsCards: {
      type: Array,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
    membershipInCart: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['error', 'success', 'warn'],
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    addedToCartText() {
      return null;
    },
  },
  methods: {
    /* c8 ignore start */
    handleClick() {
      metricsLink('A lifetime of benefits_Explore the benefits of membership');
    },
    handleMembershipClick() {
      metricsLinkAddToCart('A lifetime of benefits_Add $30 lifetime membership to cart');
    },
    /* c8 ignore end */
  },
};
</script>

<style lang="scss">

.member-collection-benefits {
  background-color: $cdr-color-background-secondary;

  .step-card {
    flex: 1 0 245px;
    max-width: 245px;
    justify-content: flex-start;
    // every child but the first
    &:nth-child(n+2) {
      margin-left: $cdr-space-two-x;
    }
  }

  .step-card__inner {
    height: unset;
    min-height: 300px;
  }
  .step-card__image {
    bottom: calc(100% - 84px);
  }
}

.member-collection-benefits__decorative-image {
  width: 100%;
  min-height: 30px;
}
.member-collection-benefits__decorative-image--top {
  vertical-align: top;
}
.member-collection-benefits__decorative-image--bottom {
  vertical-align: bottom;
}

.member-collection-benefits__title {
  @include cdr-text-heading-display-1000;
  text-align: center;
  color: $cdr-color-text-brand;
  padding-top: $cdr-space-one-and-a-half-x;
  padding-bottom: $cdr-space-one-and-a-half-x;
  margin-bottom: 0;

  @include cdr-sm-mq-up {
    @include cdr-text-heading-display-1200;
  }
}

.member-collection-benefits__cards {
  @include cdr-container;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  overflow: auto;
  padding: 0 1rem;

  @include cdr-sm-mq-up {
    max-width: 1240px;
    margin: 0 auto;
  }
}

.member-collection-benefits__ctas {
  text-align: center;
  padding-top: $cdr-space-two-x;
  padding-bottom: $cdr-space-one-x;
}

.member-collection-benefits__membership-btn {
  text-align: center;
  margin-bottom: $cdr-space-three-quarter-x;
}
</style>
